import { ResponsePressTitleRegexInformation } from "./pressTitleRegex.interface";

export const adaptPressTitleRegexInformation = (
  responseData: ResponsePressTitleRegexInformation,
) => {
  return (
    responseData
      .filter(({ option }) => option !== "")
      // eslint-disable-next-line camelcase
      .map(({ dtl_cd_nm, option }) => {
        return {
          regex: new RegExp(dtl_cd_nm, "g"),
          keywordColor: option.replaceAll("#", ""),
        };
      })
  );
};
